import { render } from "./Selective-Child-View.vue?vue&type=template&id=45b1ff87&scoped=true"
import script from "./Selective-Child-View.vue?vue&type=script&lang=js"
export * from "./Selective-Child-View.vue?vue&type=script&lang=js"

import "./Selective-Child-View.vue?vue&type=style&index=0&id=45b1ff87&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45b1ff87"]])

export default __exports__